import { createI18n } from 'vue-i18n'

import { de_or_en } from "@/i18n/locale";
import { messages } from "@/i18n/translations";

function initLocale() {
  const lang = de_or_en();
  document.querySelector("html").setAttribute("lang", lang);
  return lang;
}

export const i18n = createI18n({
  legacy: false,
  locale: initLocale(),
  fallbackLocale: "de",
  messages,
});
